import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IGetVehicleTachographFileSchedule } from '@src/app/interfaces/api/files-ddd.interface';
import { diffInDays } from '@src/app/utils/date';

@Component({
  selector: 'app-tachograph-list-download-deadline',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './tachograph-list-download-deadline.component.html',
  styleUrls: ['./tachograph-list-download-deadline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TachographListDownloadDeadlineComponent {
  @Input('data') set tachoData(data: IGetVehicleTachographFileSchedule) {
    this.daysToDeadline.set(diffInDays(new Date().toISOString(), data.MandatedLoadDate));
  };

  public daysToDeadline = signal<number>(null!);
}
